import { render, staticRenderFns } from "./TheMyFavoritesProductOptions.vue?vue&type=template&id=08f7024c&scoped=true"
import script from "./TheMyFavoritesProductOptions.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesProductOptions.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesProductOptions.vue?vue&type=style&index=0&id=08f7024c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7024c",
  null
  
)

export default component.exports